// document.title = "在线充值";
import { defineComponent, ref } from "vue";
import { showNotify, showDialog } from "vant";
import { useRouter, useRoute } from "vue-router";
import { pay, queryPayRes } from "@/api/recharge";
export default defineComponent({
  name: "Recharge",
  setup() {
    // 控制只能在微信端打开
    // if (!isWeChat()) {
    //   window.location.href =
    //     "https://hrzx.saniuer.cn/prod-api/wxapi/wechat/auth?callback=https%3A%2F%2Fhrzx.saniuer.cn%2F%23%2FMy";
    //   return;
    // }
    // const info = reactive({
    //   total: 1200,
    // });
    // 返回按钮
    // const onClickLeft = () => history.back();
    let current = ref(50);
    // 点击预设金额框事件
    const moneyClcik = num => {
      current.value = num;
    };
    // 预设金额提交事件
    const submit = () => {
      postPay(current.value);
    };
    let show = ref(false); // 控制自定义金额弹出框
    const money = ref(""); // 自定义金额数
    const isError = ref(false); // 是否显示错误提示
    // 点击自定义金额框事件
    const otherMoney = () => {
      show.value = true;
      money.value = "";
      isError.value = false;
    };
    // 自定义金额弹出框关闭之前事件 可控制弹出框是否关闭 true/false
    const customConfirm = action => {
      if (action === "confirm") {
        // 点击确认按钮
        isError.value = !(money.value && money.value > 0); // 判断用户是否有输入金额
        if (!isError.value) {
          // 调用微信支付接口
          postPay(money.value);
          show.value = false;
        }
        return !isError.value;
      } else {
        // 点击取消按钮
        return true;
      }
    };
    // 调用后台接口下单
    const loading = ref(false);
    const router = useRouter();
    const postPay = total => {
      // if (total <= 0) {
      //   showNotify({ type: "warning", message: "充值金额需要大于0" });
      //   return;
      // }
      loading.value = true;
      pay({
        total
      }).then(({
        code,
        data
      }) => {
        if (code === 200) {
          onBridgeReady(data);
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    const onBridgeReady = obj => {
      WeixinJSBridge.invoke("getBrandWCPayRequest", {
        appId: obj.appId,
        timeStamp: obj.timeStamp,
        nonceStr: obj.nonceStr,
        package: obj.packageValue,
        signType: obj.signType,
        paySign: obj.paySign
      }, res => {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          // router.push({
          //   path: "/consume/recharge/success",
          //   query: { id: obj.outTradeNo },
          // });
          // 采取刷新当前页面数据方式提醒
          queryPayRes({
            outTradeNo: obj.outTradeNo
          }).then(({
            code,
            data
          }) => {
            // 成功
            // showNotify({ type: "success", message: "充值成功" });
            // amount.value = data;
            const isSuccess = data === null || data === void 0 ? void 0 : data.isSuccess;
            showDialog({
              title: "提醒",
              // message: `充值${isSuccess ? "成功" : "失败"}`,
              message: data === null || data === void 0 ? void 0 : data.msg
            }).then(() => {
              if (isSuccess) {
                amount.value = data === null || data === void 0 ? void 0 : data.amount;
              }
            });
          });
        }
        if (res.err_msg === "get_brand_wcpay_request:cancel") {
          // 支付取消
          showNotify({
            type: "warning",
            message: "支付取消"
          });
        }
        if (res.err_msg === "get_brand_wcpay_request:fail") {
          // 支付失败
          showNotify({
            type: "warning",
            message: "支付失败"
          });
        }
      });
    };
    const route = useRoute();
    let amount = ref();
    const user = JSON.parse(localStorage.getItem("userInfo") || "{}");
    amount.value = user === null || user === void 0 ? void 0 : user.amount;
    // getInfo().then(({ data }) => {
    //   amount.value = data?.amount;
    // });
    // watch(
    //   () => route.query,
    //   (val: any) => {
    //     console.log(val);
    //     amount.value = val.amount;
    //   },
    //   { immediate: true }
    // );
    return {
      // info,
      amount,
      // onClickLeft,
      current,
      moneyClcik,
      show,
      money,
      isError,
      otherMoney,
      customConfirm,
      loading,
      submit
    };
  }
});